import { render, staticRenderFns } from "./centerPeopleGender.vue?vue&type=template&id=688df15e&scoped=true"
import script from "./centerPeopleGender.vue?vue&type=script&lang=js"
export * from "./centerPeopleGender.vue?vue&type=script&lang=js"
import style0 from "./centerPeopleGender.vue?vue&type=style&index=0&id=688df15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688df15e",
  null
  
)

export default component.exports